import { READ_FILE } from './read_file';
/**
 * 
 * @param {Blob} file 
 * @returns 
 */
export const FILE_TO_BYTE_ARRAY = async(file) => {
    return new Uint8Array(await READ_FILE(file));
}